(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('firmwareFilter', firmwareFilter);

    function firmwareFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                objectType: '&',
                objectTypeVal: '&'
            },
            template:   '<div class="row">\n' +
                        '    <div class="col-xs-12">\n' +
                        '        <div class="portlet light filter-portlet bordered">\n' +
                        '            <div class="portlet-body form">\n' +
                        '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
                        '                    <div class="form-body">\n' +
                        '                       <div class="row">\n' +
                        '                            <div class="col-xs-5">\n' +
                        '                                <div class="form-group">\n' +
                        '                                    <label for="field_objectType">Object Type</label>\n' +
                        '                                    <ui-select ng-model="vm.objectType" id="field_objectType" theme="bootstrap" ng-keyup="vm.searchObjectType($select.search)" ng-click="vm.searchObjectType($select.search)">\n' +
                        '                                    <ui-select-match\n' +
                        '                                       placeholder="Select or search an object type...">\n' +
                        '                                       {{$select.selected.objectTypeName}}\n' +
                        '                                    </ui-select-match>\n' +
                        '                                    <ui-select-choices repeat="item in vm.tabObjectTypes | filter: {objectTypeName: $select.search}" when-scrolled="vm.loadPageObjectType(vm.objectTypePage + 1)">\n' +
                        '                                       <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
                        '                                    </ui-select-choices>\n' +
                        '                                    </ui-select>\n' +
                        '                                </div>\n' +
                        '                            </div>\n' +
                        '                            <div class="col-xs-2 inline-filter-button">\n' +
                        '                                <div class="form-group">\n' +
                        '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
                        '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
                        '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
                        '                                    </button>\n' +
                        '                                </div>\n' +
                        '                            </div>\n' +
                        '                       </div>\n' +
                        '                    </div>\n' +
                        '                </form>\n' +
                        '            </div>\n' +
                        '        </div>\n' +
                        '    </div>\n' +
                        '</div>\n',
            controller: FirmwareController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    FirmwareController.$inject = ['TabObjectTypes'];

    function FirmwareController (TabObjectTypes) {
        const vm = this;
        vm.objectTypePage = 0;
        vm.tabObjectTypes = [];

        const allObjectType = {
            id: -1,
            objectTypeName: 'All'
        };

        vm.objectType = +vm.objectTypeVal() === -1 || vm.objectTypeVal().id === -1 ? allObjectType : vm.objectTypeVal();

        vm.submit = function () {
            vm.filter({objectType: vm.objectType});
        };

        vm.loadAllObjectType = function () {
            TabObjectTypes.query({
                query: vm.charToSearch,
                page: vm.objectTypePage,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.charToSearch = "";
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
            }

            function onError(error) {
            }
        };

        vm.searchObjectType = function (search){
            vm.tabObjectTypes = [];
            vm.charToSearch = search;
            vm.loadAllObjectType();
            vm.tabObjectTypes.unshift(allObjectType);
        }


        vm.loadAllObjectType();
        vm.tabObjectTypes.unshift(allObjectType);
    }
})();
